export interface Testimonial {
  name: string
  role?: string
  country: string
  /** ISO 3166-1 alpha-2 code, used for the flag image */
  countryCode: string
  text: string
}

/**
 * Fictional review placeholders showing the intended layout — not verified customer reviews.
 * Replace them with authentic, permissioned customer reviews before publishing.
 */
export const testimonials: Testimonial[] = [
  {
    name: 'Michael Anderson',
    country: 'United States',
    countryCode: 'us',
    text: "The industrial illustrations and hazard-recognition activities are exactly the kind of resources I've been looking for. Having everything organized into one system would make preparing safety training sessions much easier.",
  },
  {
    name: 'James Mitchell',
    country: 'United Kingdom',
    countryCode: 'gb',
    text: "I particularly like the mechanical safety diagrams and the correct-versus-incorrect comparisons. They're clear, professional, and make technical safety concepts much easier to explain.",
  },
  {
    name: 'Daniel Cooper',
    country: 'Canada',
    countryCode: 'ca',
    text: 'The combination of visual training materials, workplace scenarios and instructor resources is impressive. It looks like a practical addition to a professional safety training library.',
  },
]
